import { useSelector } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, StyledEngineProvider } from '@mui/material';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Routes from 'routes';
import themes from 'themes';
import NavigationScroll from 'layout/NavigationScroll';
import Loader from 'ui-component/Loader';
import { Box } from '@mui/system';
import { useState } from 'react';
import { useEffect } from 'react';
import { useLocation } from 'react-router';
const App = () => {
  const customization = useSelector((state) => state.customization);
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => {
      setLoading(false);
    }, 500);
    return () => clearTimeout(timer);
  }, [location]);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={themes(customization)}>
        <CssBaseline />
        <ToastContainer />
        <Box
          sx={{
            minHeight: '100vh',
            position: 'relative'
          }}
        >
          {loading && (
            <Box
              sx={{
                position: 'fixed',
                inset: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: 'rgba(255, 255, 255, 0.7)',
                zIndex: 9999,
              }}
            >
              <Loader />
            </Box>
          )}
          <NavigationScroll>
            <Routes />
          </NavigationScroll>
        </Box>
      </ThemeProvider>
    </StyledEngineProvider>

  );
};

export default App;